export var isPositiveNumber = function isPositiveNumber(value) {
  var number = parseInt(value, 10);
  return !value || number > 0 ? undefined : 'Error: Field must be a number greater than zero.';
};
export var isCorrectLength = function isCorrectLength(value, len) {
  return !value || value.length === len ? undefined : "Error: Field must be ".concat(len, " characters.");
};
export var isUnderMaxLength = function isUnderMaxLength(value, len) {
  return !value || value.length <= len ? undefined : "Error: Field length can not be greater than ".concat(len, " characters.");
};
export var isValidPhoneNumber = function isValidPhoneNumber(value) {
  var len = value ? value.toString().length : 0;
  return len === 0 || len < 15 && /^\d+$/.test(value) ? undefined : 'Error: Phone number must be 1-14 digits.';
};
export var isAlphanumeric = function isAlphanumeric(value) {
  return !value || /^[a-z\d\s]+$/i.test(value) ? undefined : 'Error: Field can be letters and numbers only.';
};
export var isRequired = function isRequired(value) {
  return !value ? 'Error: Field is required.' : undefined;
};
export var hasSelection = function hasSelection(value) {
  return !value.length ? 'Error: At least one item must be selected.' : undefined;
};
export var LimitedStringValidation = function LimitedStringValidation(value) {
  return !value || /^[-.@ A-Za-z0-9]+$/.test(value) ? undefined : 'Error: Value may only contain alpha numeric characters, @, space, hyphen, and period.';
};